import { siteData } from '@/mocks/siteData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-primary-100 text-primary-700 rounded-full text-xs font-label mb-3">
            <i className="ri-article-line"></i>深度爆料
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            深度揭秘 · 内幕追踪
          </h2>
          <p className="text-sm text-foreground-500 max-w-[500px] mx-auto">
            独家调查报道，还原娱乐圈最真实的一面
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {siteData.cards.map((card) => (
            <article
              key={card.id}
              className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden aspect-[16/10] bg-background-100">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 object-top"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-[10px] font-label px-2.5 py-1 rounded-full bg-primary-500 text-background-50">
                    {card.category}
                  </span>
                </div>
              </div>

              <div className="p-5 md:p-6">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-3 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-2">
                  {card.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{card.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {card.views}阅读
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 text-center">
          <a
            href="#carousel"
            className="whitespace-nowrap inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-label cursor-pointer"
          >
            查看更多深度报道
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}